var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeCancellationShield = function SvgFreeCancellationShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03288 14.6668L10.5911 13.2729C11.7946 12.6165 12.7665 11.605 13.3744 10.3762C13.9822 9.14746 14.1965 7.76117 13.988 6.40622L13.4874 3.15168C9.85107 3.15168 8.03288 1.3335 8.03288 1.3335C8.03288 1.3335 6.2147 3.15168 2.57834 3.15168L2.07773 6.40501C1.86897 7.76015 2.08313 9.1467 2.69101 10.3757C3.2989 11.6047 4.27095 12.6164 5.4747 13.2729L8.03288 14.6668Z",
    fill: "url(#paint0_linear_5365_36355)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82172 10.4245C6.661 10.4245 6.50687 10.3606 6.39324 10.247L5.18112 9.03484C5.12323 8.97893 5.07706 8.91205 5.0453 8.83811C5.01353 8.76417 4.99682 8.68464 4.99612 8.60417C4.99542 8.5237 5.01075 8.44389 5.04122 8.36941C5.0717 8.29493 5.1167 8.22726 5.1736 8.17035C5.23051 8.11345 5.29818 8.06845 5.37266 8.03798C5.44714 8.0075 5.52695 7.99217 5.60742 7.99287C5.68789 7.99357 5.76742 8.01028 5.84136 8.04205C5.9153 8.07381 5.98218 8.11998 6.03809 8.17787L6.82172 8.9615L10.0296 5.75362C10.1439 5.64323 10.297 5.58214 10.4559 5.58352C10.6148 5.5849 10.7668 5.64864 10.8792 5.76101C10.9916 5.87338 11.0553 6.02538 11.0567 6.18429C11.0581 6.3432 10.997 6.49629 10.8866 6.61059L7.25021 10.247C7.13658 10.3606 6.98245 10.4245 6.82172 10.4245Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5365_36355",
    x1: 8.03288,
    y1: 1.28198,
    x2: 8,
    y2: 20.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D7C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27F42C"
  })))));
};
export default SvgFreeCancellationShield;